import { Component, effect, EventEmitter, inject, input, OnDestroy, Output, TemplateRef, viewChild } from "@angular/core";
import { VdsDrawer } from "../drawer";
import { VdsDrawerConfig } from "../drawer-config";
import { VdsDrawerRef } from "../drawer-ref";

const defaultConfig: VdsDrawerConfig = {
    position: "right",
    width: "400px"
};

@Component({
    selector: "vds-drawer",
    templateUrl: "./drawer.component.html",
    standalone: true
})
export class VdsDrawerComponent<T = any> implements OnDestroy {
    private drawer = inject(VdsDrawer);
    private drawerRef: VdsDrawerRef<any> | undefined;

    readonly open = input<boolean>(false);
    readonly config = input<VdsDrawerConfig>();

    drawerTpl = viewChild.required("drawerTpl", { read: TemplateRef });

    // eslint-disable-next-line @angular-eslint/no-output-native
    @Output() close = new EventEmitter<T>();

    private openDrawerEffect = effect(() => {
        const shouldBeOpen = this.open();
        const isOpen = !!this.drawerRef;

        setTimeout(() => {
            // Change detection console error without this
            if (!isOpen && shouldBeOpen) {
                this.openDrawer();
            } else if (isOpen && !shouldBeOpen) {
                this.closeDrawer();
            }
        });
    });

    public ngOnDestroy(): void {
        // setTimeout because openDrawer is sometimes on a timeout
        // when this runs and can reopen the drawer
        // after this component is already destroyed.
        setTimeout(() => this.closeDrawer());
    }

    public openDrawer(): void {
        this.drawerRef = this.drawer.open(this.drawerTpl(), {
            ...defaultConfig,
            ...(this.config() ?? {})
        });

        this.drawerRef?.afterClosed().subscribe((val) => this.close.emit(val));
    }

    public closeDrawer(): void {
        if (this.drawerRef) {
            this.drawerRef.close();
        }

        this.drawerRef = undefined;
    }
}
